import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DataUtils } from 'ng-jhipster';

import { Seller } from './seller.model';
import { SellerPopupService } from './seller-popup.service';
import { SellerService } from './seller.service';
import { ModelImage, ModelImageService } from '../model-image';
import { User, UserService } from '../../shared';
import { Device, DeviceService } from '../device';
import { Resource, ResourceService } from '../resource';
import { ApplicationArtatech, ApplicationArtatechService } from '../application';
import {JhiLanguageHelper} from '../../shared/language/language.helper';
@Component( {
    selector: 'dcs-seller-dialog',
    templateUrl: './seller-add-dialog.component.html'
} )
export class SellerAddDialogComponent implements OnInit {

    seller: Seller;
    authorities: any[];
    isSaving: boolean;

    languages: any[];

    constructor(public activeModal: NgbActiveModal,
                private jhiLanguageService: JhiLanguageService,
                private languageHelper: JhiLanguageHelper,
                private alertService: AlertService,
                private sellerService: SellerService,
                private eventManager: EventManager) {
        this.languageHelper.getAll().then( (languages) => {
            this.languages = languages;
        } );
        this.jhiLanguageService.setLocations( [ 'seller', 'user-management' ] );

    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = [ 'ROLE_USER', 'ROLE_ADMIN' ];

    }

    clear() {
        this.activeModal.dismiss( 'cancel' );
    }

    save() {
        this.isSaving = true;
        if (this.seller.id !== undefined) {
            this.sellerService.update( this.seller )
                .subscribe( (res: Seller) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        } else {
            this.sellerService.create( this.seller )
                .subscribe( (res: Seller) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        }
    }

    private onSaveSuccess(result: Seller) {
        this.eventManager.broadcast( { name: 'sellerListModification', content: 'OK' } );
        this.isSaving = false;
        this.activeModal.dismiss( result );
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError( error );
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }


    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[ i ].id) {
                    return selectedVals[ i ];
                }
            }
        }
        return option;
    }
}

@Component( {
    selector: 'dcs-seller-add-popup',
    template: ''
} )
export class SellerAddPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(private route: ActivatedRoute,
                private sellerPopupService: SellerPopupService) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe( params => {
            this.modalRef = this.sellerPopupService
                .open( SellerAddDialogComponent );


        } );
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller-add-dialog.component.ts